import React from "react";
import {useDarkMode} from "../../contexts/darkModeContext";


const OrdersGuides = () => {

    const { darkMode } = useDarkMode();

    const posts = [
        {
            id: 1,
            title: 'Selecting a customer',
            href: '#',
            description:
                'The way that you, a sales rep, selects a customer is you choose from the drop down labeled Customer. This will preload with all of your active customers and once you have selected them you will see the next three fields to the left “Industry”,  “Pricing Type”, and “Customer Code” preloaded with the data associated with that customer’s account.',
            date: 'Nov 26, 2024',
            category: { title: 'New Order Form', href: '#' },
        },
        // More posts...
    ]


    return (
    <div className="w-full rounded-lg h-screen bg-animated-gradient bg-400 animate-gradientx relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(#ffffff33_1px,transparent_1px)] bg-[size:20px_20px] animate-sparkle pointer-events-none"></div>
    
      <div className="flex items-center justify-center h-full text-white text-4xl font-bold z-10 relative">
        Magical Background
      </div>
    </div>
    );
}

export default OrdersGuides;
